import React from 'react';
import { ArrowLeftIcon, CheckCircle2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FontComparisonPage() {
  return <div className="min-h-screen bg-[#f8f8f8] text-[#111111] pb-24" data-id="element-1793">
      {/* Load fonts locally */}
      <style data-id="element-1794">
        {`
          @import url('https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&family=IBM+Plex+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap');
          
          .font-atkinson {
            font-family: 'Atkinson Hyperlegible', sans-serif;
          }
          
          .font-ibm {
            font-family: 'IBM Plex Sans', sans-serif;
          }
        `}
      </style>

      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10" data-id="element-1795">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-1796">
          <Link to="/home" className="flex items-center text-gray-500 hover:text-[#631bb7] transition-colors font-medium text-sm" data-id="element-1797">
            <ArrowLeftIcon size={18} className="mr-2" data-id="element-1798" />
            Back to Home
          </Link>
          <div className="font-semibold text-[#1a0647]" data-id="element-1799">
            Font Evaluation Tool
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-12" data-id="element-1800">
        <div className="mb-12 text-center" data-id="element-1801">
          <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-1802">
            In-App Typography Comparison
          </h1>
          <p className="text-gray-500 max-w-2xl mx-auto" data-id="element-1803">
            Comparing Atkinson Hyperlegible vs IBM Plex Sans for the Caveo
            guided walkthrough experience.
          </p>
        </div>

        {/* Comparison Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1804">
          {/* ATKINSON COLUMN */}
          <div className="space-y-8" data-id="element-1805">
            <div className="bg-[#1a0647] text-white p-4 rounded-t-xl text-center font-bold tracking-wide uppercase text-sm" data-id="element-1806">
              Atkinson Hyperlegible
            </div>

            {/* Typography Scale */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1807">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1808">
                Typography Scale
              </h2>
              <div className="space-y-6" data-id="element-1809">
                <div data-id="element-1810">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1811">
                    H1 (32px / 2rem)
                  </div>
                  <h1 className="text-2xl md:text-4xl font-bold text-[#111111]" data-id="element-1812">
                    Secure your network
                  </h1>
                </div>
                <div data-id="element-1813">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1814">
                    H2 (24px / 1.5rem)
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold text-[#111111]" data-id="element-1815">
                    Router settings
                  </h2>
                </div>
                <div data-id="element-1816">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1817">
                    H3 (20px / 1.25rem)
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-[#111111]" data-id="element-1818">
                    Step 1: Find your IP
                  </h3>
                </div>
                <div data-id="element-1819">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1820">
                    Body (16px / 1rem)
                  </div>
                  <p className="text-base text-gray-600" data-id="element-1821">
                    This is standard body text used for instructions.
                  </p>
                </div>
                <div data-id="element-1822">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1823">
                    Small (14px / 0.875rem)
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1824">
                    Helper text and secondary information.
                  </p>
                </div>
              </div>
            </div>

            {/* Readability Test */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1825">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1826">
                Readability Test
              </h2>
              <p className="text-base text-gray-700 leading-relaxed" data-id="element-1827">
                Your home Wi-Fi network is the gateway to every device in your
                house. In this walkthrough, we'll check your router settings,
                update your password, and make sure your network is hidden from
                strangers. Most people can finish this in under 10 minutes.
              </p>
            </div>

            {/* UI Simulation */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1828">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1829">
                In-App UI Simulation
              </h2>

              <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-1830">
                <div className="bg-[#f8f8f8] px-5 py-3 border-b border-gray-200 flex justify-between items-center" data-id="element-1831">
                  <span className="text-sm font-bold text-gray-500" data-id="element-1832">
                    Step 2 of 5
                  </span>
                  <span className="text-sm font-bold text-[#631bb7]" data-id="element-1833">Skip</span>
                </div>
                <div className="h-1 w-full bg-gray-200" data-id="element-1834">
                  <div className="h-1 bg-[#631bb7]" style={{
                  width: '40%'
                }} data-id="element-1835"></div>
                </div>
                <div className="p-6" data-id="element-1836">
                  <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-1837">
                    Change your admin password
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-1838">
                    Your router came with a default password printed on the
                    back. Hackers know these defaults. Let's change it to
                    something secure.
                  </p>
                  <div className="space-y-3 mb-8" data-id="element-1839">
                    <label className="flex items-center p-4 border-2 border-[#631bb7] bg-[#631bb7] bg-opacity-5 rounded-lg cursor-pointer" data-id="element-1840">
                      <div className="w-5 h-5 rounded-full border-2 border-[#631bb7] flex items-center justify-center mr-3" data-id="element-1841">
                        <div className="w-2.5 h-2.5 bg-[#631bb7] rounded-full" data-id="element-1842"></div>
                      </div>
                      <span className="font-medium text-[#111111]" data-id="element-1843">
                        I'm ready to change it
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-gray-300" data-id="element-1844">
                      <div className="w-5 h-5 rounded-full border-2 border-gray-300 mr-3" data-id="element-1845"></div>
                      <span className="font-medium text-gray-700" data-id="element-1846">
                        I need help finding it
                      </span>
                    </label>
                  </div>
                  <button className="w-full bg-[#631bb7] text-white py-3.5 rounded-lg font-bold text-base hover:bg-[#521099] transition-colors" data-id="element-1847">
                    Continue
                  </button>
                </div>
              </div>
            </div>

            {/* Weights */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1848">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1849">
                Weight Showcase
              </h2>
              <div className="space-y-4" data-id="element-1850">
                <div className="flex items-center justify-between" data-id="element-1851">
                  <span className="text-lg font-normal" data-id="element-1852">Regular (400)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1853">
                    The quick brown fox
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1854">
                  <span className="text-lg font-bold" data-id="element-1855">Bold (700)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1856">
                    The quick brown fox
                  </span>
                </div>
                <div className="mt-4 p-4 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-800 font-sans" data-id="element-1857">
                  Note: Atkinson Hyperlegible only comes in Regular and Bold
                  weights natively.
                </div>
              </div>
            </div>

            {/* UI Elements */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1858">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1859">
                Buttons & Elements
              </h2>
              <div className="space-y-6" data-id="element-1860">
                <div className="flex flex-wrap gap-4" data-id="element-1861">
                  <button className="bg-[#631bb7] text-white px-5 py-2.5 rounded-lg font-bold" data-id="element-1862">
                    Primary Button
                  </button>
                  <button className="bg-white text-[#111111] border border-gray-300 px-5 py-2.5 rounded-lg font-bold" data-id="element-1863">
                    Secondary
                  </button>
                </div>
                <div className="flex flex-wrap gap-3" data-id="element-1864">
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide flex items-center" data-id="element-1865">
                    <CheckCircle2Icon size={14} className="mr-1" data-id="element-1866" /> Completed
                  </span>
                  <span className="bg-[#1a0647] text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-1867">
                    Required
                  </span>
                </div>
                <div data-id="element-1868">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-1869">
                    Email Address
                  </label>
                  <input type="text" placeholder="name@family.com" className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-base placeholder-gray-400" readOnly data-id="element-1870" />
                </div>
              </div>
            </div>
          </div>

          {/* IBM PLEX SANS COLUMN */}
          <div className="space-y-8" data-id="element-1871">
            <div className="bg-[#1a0647] text-white p-4 rounded-t-xl text-center font-bold tracking-wide uppercase text-sm" data-id="element-1872">
              IBM Plex Sans
            </div>

            {/* Typography Scale */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1873">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1874">
                Typography Scale
              </h2>
              <div className="space-y-6" data-id="element-1875">
                <div data-id="element-1876">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1877">
                    H1 (32px / 2rem)
                  </div>
                  <h1 className="text-2xl md:text-4xl font-bold text-[#111111]" data-id="element-1878">
                    Secure your network
                  </h1>
                </div>
                <div data-id="element-1879">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1880">
                    H2 (24px / 1.5rem)
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold text-[#111111]" data-id="element-1881">
                    Router settings
                  </h2>
                </div>
                <div data-id="element-1882">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1883">
                    H3 (20px / 1.25rem)
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-[#111111]" data-id="element-1884">
                    Step 1: Find your IP
                  </h3>
                </div>
                <div data-id="element-1885">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1886">
                    Body (16px / 1rem)
                  </div>
                  <p className="text-base text-gray-600" data-id="element-1887">
                    This is standard body text used for instructions.
                  </p>
                </div>
                <div data-id="element-1888">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1889">
                    Small (14px / 0.875rem)
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1890">
                    Helper text and secondary information.
                  </p>
                </div>
              </div>
            </div>

            {/* Readability Test */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1891">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1892">
                Readability Test
              </h2>
              <p className="text-base text-gray-700 leading-relaxed" data-id="element-1893">
                Your home Wi-Fi network is the gateway to every device in your
                house. In this walkthrough, we'll check your router settings,
                update your password, and make sure your network is hidden from
                strangers. Most people can finish this in under 10 minutes.
              </p>
            </div>

            {/* UI Simulation */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1894">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1895">
                In-App UI Simulation
              </h2>

              <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-1896">
                <div className="bg-[#f8f8f8] px-5 py-3 border-b border-gray-200 flex justify-between items-center" data-id="element-1897">
                  <span className="text-sm font-semibold text-gray-500" data-id="element-1898">
                    Step 2 of 5
                  </span>
                  <span className="text-sm font-semibold text-[#631bb7]" data-id="element-1899">
                    Skip
                  </span>
                </div>
                <div className="h-1 w-full bg-gray-200" data-id="element-1900">
                  <div className="h-1 bg-[#631bb7]" style={{
                  width: '40%'
                }} data-id="element-1901"></div>
                </div>
                <div className="p-6" data-id="element-1902">
                  <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-1903">
                    Change your admin password
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-1904">
                    Your router came with a default password printed on the
                    back. Hackers know these defaults. Let's change it to
                    something secure.
                  </p>
                  <div className="space-y-3 mb-8" data-id="element-1905">
                    <label className="flex items-center p-4 border-2 border-[#631bb7] bg-[#631bb7] bg-opacity-5 rounded-lg cursor-pointer" data-id="element-1906">
                      <div className="w-5 h-5 rounded-full border-2 border-[#631bb7] flex items-center justify-center mr-3" data-id="element-1907">
                        <div className="w-2.5 h-2.5 bg-[#631bb7] rounded-full" data-id="element-1908"></div>
                      </div>
                      <span className="font-medium text-[#111111]" data-id="element-1909">
                        I'm ready to change it
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-gray-300" data-id="element-1910">
                      <div className="w-5 h-5 rounded-full border-2 border-gray-300 mr-3" data-id="element-1911"></div>
                      <span className="font-medium text-gray-700" data-id="element-1912">
                        I need help finding it
                      </span>
                    </label>
                  </div>
                  <button className="w-full bg-[#631bb7] text-white py-3.5 rounded-lg font-semibold text-base hover:bg-[#521099] transition-colors" data-id="element-1913">
                    Continue
                  </button>
                </div>
              </div>
            </div>

            {/* Weights */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1914">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1915">
                Weight Showcase
              </h2>
              <div className="space-y-4" data-id="element-1916">
                <div className="flex items-center justify-between" data-id="element-1917">
                  <span className="text-lg font-normal" data-id="element-1918">Regular (400)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1919">
                    The quick brown fox
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1920">
                  <span className="text-lg font-medium" data-id="element-1921">Medium (500)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1922">
                    The quick brown fox
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1923">
                  <span className="text-lg font-semibold" data-id="element-1924">SemiBold (600)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1925">
                    The quick brown fox
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1926">
                  <span className="text-lg font-bold" data-id="element-1927">Bold (700)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1928">
                    The quick brown fox
                  </span>
                </div>
              </div>
            </div>

            {/* UI Elements */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1929">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1930">
                Buttons & Elements
              </h2>
              <div className="space-y-6" data-id="element-1931">
                <div className="flex flex-wrap gap-4" data-id="element-1932">
                  <button className="bg-[#631bb7] text-white px-5 py-2.5 rounded-lg font-semibold" data-id="element-1933">
                    Primary Button
                  </button>
                  <button className="bg-white text-[#111111] border border-gray-300 px-5 py-2.5 rounded-lg font-semibold" data-id="element-1934">
                    Secondary
                  </button>
                </div>
                <div className="flex flex-wrap gap-3" data-id="element-1935">
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide flex items-center" data-id="element-1936">
                    <CheckCircle2Icon size={14} className="mr-1" data-id="element-1937" /> Completed
                  </span>
                  <span className="bg-[#1a0647] text-white px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide" data-id="element-1938">
                    Required
                  </span>
                </div>
                <div data-id="element-1939">
                  <label className="block text-sm font-semibold text-gray-700 mb-1" data-id="element-1940">
                    Email Address
                  </label>
                  <input type="text" placeholder="name@family.com" className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-base placeholder-gray-400" readOnly data-id="element-1941" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}